
import React from "react";
import { i18nManager } from "../../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { Siren } from "../../../../shared/ConfirmDialog";
import Notifications from "../../../../shared/Notifications";
import { NotificationGroup } from "../../../../shared/Notifiier";
import { ApiResponseData, BaseService, INotification, ITournamentEdition, SanitizedResponse, TournamentService } from "../../../../../services";
import { Checkbox, NoseurObject, Subscriber, useScreenDimension, useSubscription } from "@rivtn/noseur";
import { Schemes } from "../../../../../utils";

interface TournamentNotificationsProps {
    tournamentEdition: ITournamentEdition;
}

function TournamentNotifications(props: TournamentNotificationsProps) {

    const { tournamentEdition } = props;
    const { width } = useScreenDimension();
    let { tournamentId } = ReactRouterDom.useParams();
    const tournamentService = TournamentService.getInstance();
    const labels = i18nManager.Labels.host.manage_tournament.notifications;
    const markAsRead = useSubscription("OMNEHOST.MANAGE.TOURNAMENT.READ.NOTIFS");
    const [searchParams, _] = ReactRouterDom.useSearchParams(window.location.search);
    let editionFilter: any = { "tournament_edition.external_id": tournamentEdition.external_id, };
    useSubscription("NOTIFICATION.STATUS.UPDATE", (status: string) => {
        markAsRead(status === "READ" ? - 1 : +1);
    });

    return (<Notifications
        canGoBack
        service={tournamentService}
        subTitle={searchParams.get("name") ?? ""}
        secondaryComponents={(fetch) => {

            if (width < 800) return (<></>);

            return (<>
                <Checkbox scheme={Schemes.OMNEHOST} label={labels.show_all_edition_notifications} onChecked={(checked) => {
                    editionFilter = (checked ? {} : { "tournament_edition.external_id": tournamentEdition.external_id, });
                    fetch(undefined as any);
                }} />
            </>);
        }}
        markAllAsRead={(done, success) => {
            tournamentService.markAllNotificationsAsRead(tournamentId!).then(({ }: SanitizedResponse<void>) => {
                Siren.alert(i18nManager.Labels.compound.top_navbar.popover.notification.mark_all_read_success);
                success();
                markAsRead(0);
            }).catch(BaseService.reportError).finally(done);
        }}
        fetch={(section, done, success) => {
            tournamentService.queryNotifications({
                "tournament.external_id": tournamentId,
                page: parseInt(searchParams.get("page") ?? "1"),
                size: parseInt(searchParams.get("size") ?? "50"),
                status: (section === "unread" ? "UN_READ" : undefined),
                ...editionFilter,
            }).then(({ sanitized, apiResponse }: SanitizedResponse<ApiResponseData<INotification> & { grouped_notifications: NotificationGroup }>) => {
                success(sanitized, apiResponse.secondary_data?.un_reads?.tournament_notifications);
            }).catch(BaseService.reportError).finally(done);
        }}
    />);

}

export default TournamentNotifications;
